

import { Message, MessageBox } from "element-ui";
import Cookies from "js-cookie";
/**
 * 去商品详情
 */
export function goShopDetail(id, self) {
  self.$router.push({ path: "/goods_detail/" + id });
}

/**
 * 去店铺
 */
export function goMerchant(id, self) {
  self.$router.push({ path: "/merchant/merchant/home?id=" + id });
}

/**
 * 活动商品、普通商品、购物车、再次购买预下单
 */
export function getPreOrder(ids, self) {
  return new Promise((resolve, reject) => {
    // 直接跳转到未登录订单确认页面
    self.$router.push({
      path: `/order/order_confirmNoLogin`,
      query: { card_ids: ids }
    });
  });
}

/**
 * 取消订单
 */
export function cancelOrders(self, orderNo) {
  console.log(orderNo);
  return new Promise((resolve, reject) => {
    MessageBox.confirm(
      self.$t(`page.orderDetails.confirmCancel`),
      self.$t(`message.login.prompt`),
      {
        confirmButtonText: self.$t(`message.common.confirm`),
        cancelButtonText: self.$t(`message.common.cancel`)
      }
    ).then((res) => {
      self.$axios.post("/api/center/cancelOrder", {
        id: orderNo
      }).then((data) => {
        resolve(res);
        return Message.success(self.$t(`message.login.calSU`));
      });
    });
  });
}

/**
 * 删除订单
 */
export function delOrders(self, orderNo) {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(
      self.$t(`page.orderDetails.confirmDel`),
      self.$t(`message.login.prompt`),
      {
        confirmButtonText: self.$t(`message.common.confirm`),
        cancelButtonText: self.$t(`message.common.cancel`)
      }
    ).then((res) => {
      self.$axios.post("/api/front/order/delete/" + orderNo).then((data) => {
        resolve(res);
        return Message.success(self.$t(`message.login.delSU`));
      });
    });
  });
}

/**
 * 待支付订单去付款
 */
export function goPay(self, item) {
  console.log(item);
  return new Promise((resolve, reject) => {
    MessageBox.confirm(
      self.$t(`message.tips.surePay`),
      self.$t(`message.login.prompt`),
      {
        confirmButtonText: self.$t(`message.common.confirm`),
        cancelButtonText: self.$t(`message.common.cancel`)
      }
    ).then((r) => {
      if (item.payment == 1) {
        self.$axios
          .post("/api/pay/pay", {
            orderid: item.orderid,
          })
          .then((res) => {
            // 打开支付页面
            window.open(res.data, '_blank');
          });
      } else if (item.payment == 2) {
        self.$axios
          .post("/api/paytwo/create", {
            orderid: item.orderid,
          })
          .then((res) => {
            // 打开支付页面
            window.open(res.data, '_blank');
          });
      }
    });
  });
}

/**
 * 关注、取消关注商品
 */
export function followPro(self, follow, id) {
  return new Promise((resolve, reject) => {
    // if (!follow) {
      self.$axios
        .post("/api/center/collect", {
          id: id,
        })
        .then((res) => {
          resolve(res);
        });
    // } else {
    //   self.$axios.post(`/api/front/collect/cancel/${id}`).then((res) => {
    //     resolve(res);
    //   });
    // }
  });
}

/**
 * 关注、取消关注店铺
 */
export function followMer(self, follow, id) {
  return new Promise((resolve, reject) => {
    if (!follow) {
      self.$axios.post(`/api/front/collect/add/merchant/${id}`).then((res) => {
        resolve(res);
      });
    } else {
      self.$axios
        .post(`/api/front/collect/cancel/merchant/${id}`)
        .then((res) => {
          resolve(res);
        });
    }
  });
}

/**
 *获取所在地
 */
export function getIpInfo(self) {
  return new Promise((resolve, reject) => {
    self.$axios.post("/api/front/address/ip/info").then((res) => {
      resolve(res);
    });
  });
}